import { __assign, __extends, __rest } from "tslib";
import React from "react";
import { SectionList, View, ScrollView, Text } from "react-native";
import PropTypes from "prop-types";
var PnmacSectionListView = /** @class */function (_super) {
  __extends(PnmacSectionListView, _super);
  function PnmacSectionListView(props) {
    var _this = _super.call(this, props) || this;
    _this.closeItem = function (item) {
      var st = __assign({}, _this.state);
      if (st.collapsed.indexOf(item) > -1) {
        st.collapsed.splice(st.collapsed.indexOf(item), 1);
      }
      _this.setState({
        collapsed: st.collapsed
      });
    };
    _this.collapseItem = function (item) {
      var st = _this.state;
      if (st.collapsed.indexOf(item) > -1) {
        st.collapsed.splice(st.collapsed.indexOf(item), 1);
      } else {
        st.collapsed.push(item);
        if (st.expandCallback != null) {
          st.expandCallback(item);
        }
      }
      _this.setState({
        collapsed: st.collapsed
      });
    };
    _this.expandItemOpen = function (item) {
      var st = _this.state;
      if (st.collapsed.indexOf(item) == -1) {
        st.collapsed.push(item);
        _this.setState({
          collapsed: st.collapsed
        });
      }
    };
    _this.state = {
      collapsed: props.openDefaults || [],
      expandCallback: props.expandCallback || null
    };
    return _this;
  }
  PnmacSectionListView.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      renderItem = _a.renderItem,
      collapsableSections = _a.collapsableSections,
      renderSectionHeader = _a.renderSectionHeader,
      data = _a.data,
      noShadow = _a.noShadow,
      rest = __rest(_a, ["renderItem", "collapsableSections", "renderSectionHeader", "data", "noShadow"]);
    return /*#__PURE__*/React.createElement(ScrollView, {
      style: {
        overflow: 'visible'
      }
    }, data.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: String(index) + item.title
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          boxShadow: !noShadow ? "rgba(0, 0, 0, 0.08) 2px 4px 12px" : undefined,
          transition: "all .3s cubic-bezier(0,0,.5,1)",
          backgroundColor: '#FFF',
          overflow: 'visible',
          marginTop: 10,
          marginBottom: 10,
          borderRadius: 10,
          "hover": {
            transform: "scale(1.1)"
          }
        }
      }, renderSectionHeader({
        section: item
      }), item.data.map(function (dataItem, dataIndex) {
        return collapsableSections ? renderItem({
          item: dataItem,
          index: dataIndex
        }, _this.state.collapsed) : renderItem({
          item: dataItem,
          index: dataIndex
        });
      })));
    }));
  };
  return PnmacSectionListView;
}(React.Component);
PnmacSectionListView.propTypes = {
  renderSectionHeader: PropTypes.func,
  collapsableSections: PropTypes.bool,
  renderItem: PropTypes.func,
  data: PropTypes.array
};
export default PnmacSectionListView;